import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { ComponentId } from "./enums";

export type FormInput = {
  [ComponentId.CORRECTNESS_AGREEMENT]: string;
  [ComponentId.CONTACT_AGREEMENT]: string;
};

export type FormDataInputs = FormInput;

const initialState: FormInput = {
  [ComponentId.CORRECTNESS_AGREEMENT]: "",
  [ComponentId.CONTACT_AGREEMENT]: "",
};

const summarySlice = createSlice({
  name: "@OC/vehicle/summary",
  initialState,
  reducers: {
    setData: (state, action: PayloadAction<FormInput>) => {
      state[ComponentId.CORRECTNESS_AGREEMENT] =
        action.payload[ComponentId.CORRECTNESS_AGREEMENT];
      state[ComponentId.CONTACT_AGREEMENT] =
        action.payload[ComponentId.CONTACT_AGREEMENT];
    },
    setOCVehicleCorrectnessAgreement: (state, action) => {
      state[ComponentId.CORRECTNESS_AGREEMENT] = action.payload;
    },
    setOCVehicleContactAgreement: (state, action) => {
      state[ComponentId.CONTACT_AGREEMENT] = action.payload;
    },
  },
});

export const {
  setData: setOCVehicleSummaryFormData,
  setOCVehicleContactAgreement,
  setOCVehicleCorrectnessAgreement,
} = summarySlice.actions;

export const { reducer } = summarySlice;
